(function() {

  const loadTl = gsap.timeline({
    defaults: {
      duration: 0.8,
      ease: 'linear',
    },
  });

  loadTl
    // .to('.line-1', {
    //   autoAlpha: 1,
    // })
    .fromTo('.line-1 > *', {
      autoAlpha: 0,
      scale: .98,
    }, {
      autoAlpha: 1,
      scale: 1,
      stagger: 1,
      transformOrigin: '0 0'
    });


  const blobTl = gsap.timeline({
    paused: true,
    defaults: {
      duration: 1,
      ease: 'linear',
    },
    once: true,
  });

  const blobPathRect = document
    .querySelector('#blob-path')
    .getBoundingClientRect();

  gsap.set('#blob-path', {
    scale: 0,
    x: window.innerWidth / 2 - blobPathRect.width / 2,
    y: window.innerHeight - blobPathRect.height / 2,
    transformOrigin: '50% 50%',
  })
    
  gsap.set('.about-anim__blob', {
    autoAlpha: 1,
  })

  const line2Split = new SplitText('.line-2', { type: 'words' });
  const line3Split = new SplitText('.line-3', { type: 'words' });

  const size = window.innerWidth > window.innerHeight ? window.innerWidth : window.innerHeight;
  const blobFinalScale = size * 0.007;

  blobTl
    .add('start')

    // .add('line-1')
    
    .to('.line-1', {
      scale: .98,
      autoAlpha: 0,
      delay: 1,
    })

    .set('.line-2', {
      autoAlpha: 1,
    })
    .fromTo(line2Split.words, {
      scale: .98,
      autoAlpha: 0,
    }, {
      scale: 1,
      autoAlpha: 1,
      stagger: .1,
      duration: 1,
      transformOrigin: '0 0',
    })

    .add('line-2')

    .to('.line-2', {
      autoAlpha: 0,
      scale: .99
    })
    .set('.line-3', {
      autoAlpha: 1,
    })
    .fromTo(line3Split.words, {
      autoAlpha: 0,
      // y: 5,
    }, {
      autoAlpha: 1,
      // y: 0,
      stagger: .15,
    })

    .add('line-3')

    .to({}, { duration: 2 })

    .add('blob-start')

    .to('.about-anim__text', {
      pointerEvents: 'none',
      duration: 0.1
    })

    .to('.line-3', {
      autoAlpha: 0,
    }, 'blob-start-=0.2')

    .to('#blob-path', {
      scale: 4,
      x: window.innerWidth / 2 - blobPathRect.width / 2,
      y: window.innerHeight / 2 - blobPathRect.height / 2,
      transformOrigin: '50% 50%',
      duration: 3,
    }, 'blob-start')
    
    
    .to('#blob-path', {
      scale: blobFinalScale,
    })
    .fromTo('.about-anim__video-play', {
      autoAlpha: 0,
      scale: 0.9,
    }, {
      autoAlpha: 1,
      scale: 1,
    }, '<')

    .add('end-1')
    .to({}, { duration: 1 })
    .add('end-2')
    .to({}, { duration: 1 })


  const blobST = ScrollTrigger.create({
    trigger: '.about-anim__section',
    start: 'top top',
    end: '+=400%',
    animation: blobTl,
    scrub: 0.5,
    pin: true,
    snap: 'labelsDirectional',
    onUpdate: function(ST) {
      document.body.classList.toggle('navbar--scrolled', ST.progress >= 0.999);
    }
  })

  window.blobST = blobST;

  document.addEventListener('DOMContentLoaded', function() {
    const video = $('.about-anim__clip video:visible').get(0);
    $('.about-anim__video-play').on('click', function() {
      video.play();
    });
  
    video.addEventListener('click', function() {
      video.paused ? video.play() : video.pause();
    });

    video.addEventListener('play', function() {
      $('.about-anim__video-play').fadeOut();
    });
    
    video.addEventListener('pause', function() {
      $('.about-anim__video-play').fadeIn();
    });

    video.addEventListener('ended', function() {
      $('.about-anim__video-play').fadeIn();
      video.currentTime = 0;
    });
    
  });




  const journeyTl = gsap.timeline({ paused: true });
  const journeyST = ScrollTrigger.create({
    trigger: '.about-hero__curve',
    start: 'top 75%',
    // end: 'bottom 50%',
    animation: journeyTl,
  })

  journeyTl.fromTo('.about-indigo', { 
    drawSVG: '100% 100%'
  }, {
    drawSVG: '100% 0%',
    duration: 7
  });


  const videos = document.querySelectorAll('.about-anim__clip video');
  const observer = new IntersectionObserver(function (entries) {
    if (!entries[0].isIntersecting) {
      videos.forEach(video => video.pause());
    }
  });
  observer.observe(document.querySelector(".about-anim__clip"))

})();
